module.exports = __webpack_public_path__ + "img/landing2Large.91fdf706.jpg";